// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3Lw-j","content":"LoadingAlert_content__2WEQn"};